export default "__VITE_ASSET__B35POogv__"